// extracted by mini-css-extract-plugin
module.exports = {"About":"About_About__scHdH","Credits":"About_Credits__2_w3X"};